/* Real brand logos via uploaded assets */

const LOGOS = {
  "Schneider Electric": "https://customer-assets.emergentagent.com/job_services-electro-dao/artifacts/r5wptd65_Schneider_Electric-Logo.wine.png",
  "Hager": "https://customer-assets.emergentagent.com/job_services-electro-dao/artifacts/0f8kwz8j_R%20%281%29.png",
  "Legrand": "https://customer-assets.emergentagent.com/job_services-electro-dao/artifacts/s2rztrmv_png-clipart-logo-legrand-electricals-brand-graphics-general-electric-text-logo.png",
  "Wallbox": "https://customer-assets.emergentagent.com/job_services-electro-dao/artifacts/c2lbezkc_wallbox-logo.png",
};

export function BrandLogo({ name, className = "" }) {
  const src = LOGOS[name];
  if (!src) return <span className={className}>{name}</span>;
  return (
    <img
      src={src}
      alt={name}
      loading="lazy"
      className={`max-h-12 sm:max-h-14 w-auto object-contain ${className}`}
    />
  );
}

export const IRVE_BRANDS = ["Schneider Electric", "Hager", "Legrand", "Wallbox"];
